export const heroSlides = [
  {
    id: 1,
    title: '暑期档热映大片《龙马精神》',
    subtitle: '成龙领衔主演，温情动作巨制火热上线',
    category: '电影',
    tag: '热播推荐',
    platform: '芒果视频',
    url: '/article/1',
  },
  {
    id: 2,
    title: '《乘风破浪的姐姐》第六季',
    subtitle: '全新阵容集结，姐姐魅力席卷盛夏',
    category: '综艺',
    tag: '独家上线',
    platform: '芒果视频',
    url: '/article/2',
  },
  {
    id: 3,
    title: '《风起洛阳》重磅回归',
    subtitle: '古装悬疑大剧，黄轩王一博再度联手',
    category: '电视剧',
    tag: '热播中',
    platform: '西瓜视频免费',
    url: '/article/3',
  },
];

export const categories = [
  { id: 'movie', name: '电影', icon: 'ri-film-line', count: 1286 },
  { id: 'tv', name: '电视剧', icon: 'ri-tv-line', count: 963 },
  { id: 'variety', name: '综艺', icon: 'ri-emotion-laugh-line', count: 547 },
  { id: 'anime', name: '动漫', icon: 'ri-rocket-line', count: 832 },
  { id: 'documentary', name: '纪录片', icon: 'ri-global-line', count: 321 },
  { id: 'kids', name: '少儿', icon: 'ri-bear-smile-line', count: 456 },
];

export const hotRecommendations = [
  {
    id: 1,
    title: '流浪地球3',
    imageSeq: 'movie-wandering-earth-3',
    rating: 9.2,
    year: 2026,
    category: '电影',
    platform: '西瓜视频免费',
    updateInfo: 'HD高清',
    url: '/article/4',
  },
  {
    id: 2,
    title: '繁花',
    imageSeq: 'tv-fanhua',
    rating: 9.5,
    year: 2024,
    category: '电视剧',
    platform: '芒果视频',
    updateInfo: '全30集',
    url: '/article/5',
  },
  {
    id: 3,
    title: '奔跑吧兄弟第十二季',
    imageSeq: 'variety-running-man',
    rating: 8.8,
    year: 2026,
    category: '综艺',
    platform: '小蓝视频',
    updateInfo: '更新至第8期',
    url: '/article/6',
  },
  {
    id: 4,
    title: '哪吒之魔童闹海',
    imageSeq: 'anime-nezha-2',
    rating: 9.6,
    year: 2025,
    category: '动漫',
    platform: '茄子视频',
    updateInfo: 'HD高清',
    url: '/article/7',
  },
  {
    id: 5,
    title: '唐朝诡事录之西行',
    imageSeq: 'tv-tang-dynasty',
    rating: 9.0,
    year: 2026,
    category: '电视剧',
    platform: '芒果视频',
    updateInfo: '更新至第24集',
    url: '/article/8',
  },
  {
    id: 6,
    title: '飞驰人生3',
    imageSeq: 'movie-pegasus-3',
    rating: 8.9,
    year: 2026,
    category: '电影',
    platform: '西瓜视频免费',
    updateInfo: 'HD高清',
    url: '/article/9',
  },
  {
    id: 7,
    title: '中国新说唱2026',
    imageSeq: 'variety-rap-china',
    rating: 8.5,
    year: 2026,
    category: '综艺',
    platform: '小蓝视频',
    updateInfo: '更新至第5期',
    url: '/article/10',
  },
  {
    id: 8,
    title: '深海2',
    imageSeq: 'anime-deep-sea-2',
    rating: 9.3,
    year: 2026,
    category: '动漫',
    platform: '茄子视频',
    updateInfo: 'HD高清',
    url: '/article/11',
  },
];

export const latestUpdates = [
  {
    id: 101,
    title: '孤注一掷2',
    category: '电影',
    platform: '芒果视频',
    updateTime: '2小时前',
    url: '/article/12',
    imageSeq: 'movie-no-more-bets-2',
  },
  {
    id: 102,
    title: '山海情第二季',
    category: '电视剧',
    platform: '西瓜视频免费',
    updateTime: '3小时前',
    url: '/article/13',
    imageSeq: 'tv-minning-town-2',
  },
  {
    id: 103,
    title: '极限挑战第十一季',
    category: '综艺',
    platform: '小蓝视频',
    updateTime: '5小时前',
    url: '/article/14',
    imageSeq: 'variety-go-fighting-11',
  },
  {
    id: 104,
    title: '长安三万里2',
    category: '动漫',
    platform: '茄子视频',
    updateTime: '6小时前',
    url: '/article/15',
    imageSeq: 'anime-changan-2',
  },
  {
    id: 105,
    title: '封神第二部',
    category: '电影',
    platform: '西瓜视频免费',
    updateTime: '8小时前',
    url: '/article/16',
    imageSeq: 'movie-fengshen-2',
  },
  {
    id: 106,
    title: '大江大河4',
    category: '电视剧',
    platform: '芒果视频',
    updateTime: '10小时前',
    url: '/article/17',
    imageSeq: 'tv-like-a-flowing-river-4',
  },
];

export const platformPartners = [
  { name: '西瓜视频免费', desc: '海量影视资源', icon: 'ri-vidicon-line' },
  { name: '小蓝视频', desc: '独家综艺节目', icon: 'ri-live-line' },
  { name: '茄子视频', desc: '热门动漫番剧', icon: 'ri-movie-line' },
  { name: '芒果视频', desc: '热门电视剧集', icon: 'ri-tv-2-line' },
];

export const siteStats = [
  { label: '视频资源', value: '50,000+', icon: 'ri-film-line' },
  { label: '日均更新', value: '200+', icon: 'ri-refresh-line' },
  { label: '在线用户', value: '800万+', icon: 'ri-user-line' },
  { label: '合作平台', value: '10+', icon: 'ri-team-line' },
];